$(document).on('submit', 'form.form-api', function (event) {
    event.preventDefault();

    let url = $(this).attr('action');
    let modal = $(this).parents('.modal');

    $.post(url, $(this).serialize(), function (modal, data) {
        if(data.redirect) {
            window.location.href = data.redirect;
        } else if (data.id) {
            $(this).find('input').val('');
            $(this).find('textarea').html('');

            // Скрываем content
            $(modal).find('.modal__content').hide();

            // Выводим сообщение
            $(modal).find('.modal__success').show();

            // Закрываем форму через N секунд
            setTimeout(function () {
                $(this).parents('.modal').find('.modal__close').click();
            }.bind(this), 2500);

            if (typeof ym === 'function' && window.metrica_id) {
                ym(window.metrica_id, 'reachGoal', 'click-forms-send');
            }
        }
    }.bind(this, modal)).fail(function (modal, response){
        if (response.responseJSON.errors) {
            $(modal).find('.modal__error').html('').hide();
            $(modal).find('.input__error').remove();
            $(modal).find('.form__input.error').removeClass('error');

            $.each(response.responseJSON.errors, function (name, error) {
                $(modal).find("[name=" + name + "]").after(
                    $("<span/>").addClass('input__error').html(error)
                ).addClass('error');
            });
        } else if(response.responseJSON.error) {
            $(modal).find('.modal__error').html(response.responseJSON.error).show();
        }
    }.bind(this, modal));
});
